import script from "./AppConfirmationCode.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConfirmationCode.vue?vue&type=script&setup=true&lang=js"

import "./AppConfirmationCode.vue?vue&type=style&index=0&id=12528062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12528062"]])

export default __exports__